import { render, staticRenderFns } from "./replace-tip-wrap.vue?vue&type=template&id=3ffea5bb&scoped=true&"
import script from "./replace-tip-wrap.vue?vue&type=script&lang=js&"
export * from "./replace-tip-wrap.vue?vue&type=script&lang=js&"
import style0 from "./replace-tip-wrap.vue?vue&type=style&index=0&id=3ffea5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffea5bb",
  null
  
)

export default component.exports